import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Slide,
  Typography,
} from '@mui/material';
import { ContainerWithLoader } from 'components/container-with-loader/container-with-loader';
import { VisibilityButton } from 'components/visibility-button/visibility-button';
import { Colors } from 'constants/colors';
import { fontPrimary, fontSecondary } from 'constants/font-family';
import { FontSizes } from 'constants/font-sizes';
import { SeverityChip } from 'pages/policies/components/severity-chip/severity-chip';
import { ReactComponent as GitHubIcon } from 'assets/icons/github.svg';
import { ReactComponent as GitlabIcon } from 'assets/icons/gitlab.svg';
import { ReactComponent as BitBucketIcon } from 'assets/icons/bitbucket.svg';
import { ReactComponent as AzureDevopsIcon } from 'assets/icons/azuredevops.svg';
import { ReactComponent as JFrogIcon } from 'assets/icons/jfrog.svg';
import { ReactComponent as EntityGraphIcon } from 'assets/icons/graph.svg';
import { ReactComponent as ActiveServiceAccount } from 'assets/icons/active-service.svg';
import { ReactComponent as InactiveServiceAccount } from 'assets/icons/inactive-service.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/cross-circle.svg';
import { ReactComponent as ShieldIcon } from 'assets/icons/shield.svg';
import { ReactComponent as ActiveUser } from 'assets/icons/active-user.svg';
import { ReactComponent as InactiveUser } from 'assets/icons/inactive-user.svg';
// import { ReactComponent as OrgAdmin } from 'assets/icons/org-admin.svg';
import { PieChart } from 'pages/teams/pages/PieChart';
import { StyledButton } from 'components/button/button';
import dayjs from 'dayjs';
import React from 'react';
import {
  ExtraCellsObject,
  TableComponent,
} from 'components/table/table-component/table-component';
import { multiToolTableStructure } from 'pages/identities/identity-details/components/identity-info/constants';
import { getReposDetailsString } from 'utils/teams/teams.utils';
import { Circle } from '@mui/icons-material';
import ReactMarkdown from 'react-markdown';
import { PackageAdvisoryModal } from 'pages/opensource-dependencies/opensource-dependency-details/components/modals/package-advisory-modal/package-advisory-modal';
import { CustomSvgIcon } from 'components/svg-icon/svg-icon';
import { ReactComponent as NPMIcon } from 'assets/icons/NPM.svg';
import { ReactComponent as OrgAdmin } from 'assets/icons/org-admin.svg';
import { ReactComponent as PyIcon } from 'assets/icons/Py.svg';
import { ReactComponent as MavenIcon } from 'assets/icons/maven.svg';
import { TransitionProps } from '@mui/material/transitions';
import { TableCellWithLink } from 'components/table/table-components/table-components';
// import { StyledTooltip } from 'components/tooltip/tooltip';
import { useNavigate } from 'react-router-dom';
import { paths } from 'constants/routes';
import {
  IDENTITY_MULTI_TOOL_MODAL,
  IDENTITY_MULTI_TOOL_TABLE,
  INFO_COMPONENT_ENTITY_GRAPH_LINK,
  INFO_COMPONENT_PROFILE_LINK,
  MULTI_TOOL_STATUS_IDENTITY_LINK,
  OPENSOURCE_DETAILS_ADVISORIES_MODAL_LINK,
  OPENSOURCE_DETAILS_PACKAGE_LINK,
  OPENSOURCE_DETAILS_README_LINK,
  OPENSOURCE_INFO_COMPONENT_MODAL,
  RISK_REASON_MODAL_LINK,
} from 'constants/test-ids';
import {
  openModalByNameAction,
  PlainModals,
} from 'store/modules/modals/modals.reducer';
import { useDispatch } from 'react-redux';
import { StyledTooltip } from 'components/tooltip/tooltip';
import { setIdentitiesDetailsTab } from 'store/modules/identities/identities.reducer';
import { ADMIN_ROLE } from 'utils/auth';
export interface InfoDetailsProps {
  id: string;
  title: string;
  isDate?: boolean;
  isLinked?: boolean;
}

interface Props {
  id?: string | undefined;
  data: any;
  isLoading: boolean;
  isError: boolean;
  infoStructure: InfoDetailsProps[];
  openRiskReasonModal?: () => void;
  goToEntityGraph?: () => void;
  changeItemHide?: any;
  changeItemWatch?: any;
  extraCellsRenderObj?: ExtraCellsObject;
  source?: any;
  marginBottom?: string;
  dataTestId: string;
  noWatchHide?: boolean;
}

export const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const renderStatus = (item: any) => {
  const status = item?.last_login
    ? true
    : item?.status
    ? item.status
    : item?.status_active
    ? item.status_active
    : false;
  return (
    <Typography
      sx={{
        color: status ? Colors.green : Colors.red,
        fontSize: FontSizes.fontSize14,
        fontFamily: fontSecondary,
        lineHeight: '22px',
      }}
    >
      <Circle
        sx={{
          color: status ? Colors.green : Colors.red,
          width: '7px',
          height: '7px',
          marginRight: '7px',
        }}
      />
      {item?.last_login
        ? dayjs(item.last_login).format('L LT')
        : item?.scm_deactivated
        ? 'Suspended'
        : status
        ? 'Active'
        : 'Inactive'}
    </Typography>
  );
};

export const RenderSourceCell = ({ source }: any) => {
  return source && source.toLowerCase() === 'gitlab' ? (
    <GitlabIcon height={20} width={20} color={Colors.blackPearl} />
  ) : source && source.toLowerCase() === 'github' ? (
    <GitHubIcon height={20} width={20} color={Colors.blackPearl} />
  ) : source && source.toLowerCase() === 'bitbucket' ? (
    <BitBucketIcon height={20} width={20} color={Colors.blackPearl} />
  ) : source && source.toLowerCase() === 'azuredevops' ? (
    <AzureDevopsIcon height={20} width={20} color={Colors.blackPearl} />
  ) : source && source.toLowerCase() === 'jfrog' ? (
    <JFrogIcon height={20} width={20} color={Colors.blackPearl} />
  ) : (
    source
  );
};

export const InfoComponent = ({
  id,
  data,
  isLoading,
  isError,
  infoStructure,
  openRiskReasonModal,
  goToEntityGraph,
  changeItemHide,
  changeItemWatch,
  extraCellsRenderObj,
  source,
  marginBottom,
  dataTestId,
  noWatchHide = false,
}: Props) => {
  const [open, setOpen] = React.useState(false);
  const [isReadMore, setIsReadMore] = React.useState(false);
  const [openOss, setOpenOss] = React.useState(false);
  const [openPieChart, setOpenPieChart] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOssOpen = () => {
    setOpenOss(true);
  };

  const handleOssClose = () => {
    setIsReadMore(false);
    setOpenOss(false);
  };

  const handlePieChartOpen = () => {
    setOpenPieChart(true);
  };

  const handlePieChartClose = () => {
    setOpenPieChart(false);
  };

  const renderLogin = (data: any) => {
    return (
      <>
        {data?.login ? (
          <TableCellWithLink
            handleClick={() => {
              handleClose();
              dispatch(setIdentitiesDetailsTab(0));
              navigate(
                `${paths.identityDetails}?user=${data?.login}&source=${data?.source}`,
              );
            }}
            isActive={true}
            itemTitle={data.login}
            align="left"
            dataTestId={MULTI_TOOL_STATUS_IDENTITY_LINK}
          />
        ) : (
          '-'
        )}
      </>
    );
  };

  const extraTableCellsRenderObject: ExtraCellsObject = {
    login: renderLogin,
  };

  const RenderDisplayName = () => {
    return (
      <Box
        sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}
        data-testid={dataTestId}
      >
        {data.account_type === 'user' && (
          <Box>
            {data?.status_active ? (
              <ActiveUser color={Colors.active} />
            ) : (
              <InactiveUser color={Colors.lightRed} />
            )}
          </Box>
        )}
        {data.account_type === 'service' && (
          <Box>
            {data?.status_active ? (
              <ActiveServiceAccount color={Colors.active} />
            ) : (
              <InactiveServiceAccount color={Colors.lightRed} />
            )}
          </Box>
        )}
        <Typography
          onClick={handleClickOpen}
          sx={{
            fontSize: FontSizes.fontSize14,
            fontFamily: fontSecondary,
            color: Colors.binge,
            cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          {data.display_name ? data.display_name : data.login}
        </Typography>
        {data.org_roles &&
          Object.values(data.org_roles).includes(ADMIN_ROLE) && (
            <StyledTooltip
              title={
                <Box>
                  {typeof data.org_roles === 'object' &&
                    Object.keys(data.org_roles).map((org) => (
                      <>
                        {data.org_roles[org] === ADMIN_ROLE && (
                          <Typography color={Colors.white}>{org}</Typography>
                        )}
                      </>
                    ))}
                </Box>
              }
            >
              <Box ml={'2px'} mt={'5px'}>
                <OrgAdmin />
              </Box>
            </StyledTooltip>
          )}
      </Box>
    );
  };

  const RenderRiskRating = (props: { isLinked?: boolean }) => {
    const { isLinked } = props;
    return (
      <>
        {data?.highest_severity && (
          <Box
            sx={{ cursor: 'pointer' }}
            onClick={openRiskReasonModal}
            data-testid={RISK_REASON_MODAL_LINK}
          >
            <SeverityChip
              severityScore={parseInt(data?.highest_severity)}
              showText={true}
            />
          </Box>
        )}
        {!data?.highest_severity && (
          <Box onClick={isLinked ? openRiskReasonModal : () => {}}>
            <Typography
              sx={{
                fontSize: FontSizes.fontSize12,
              }}
            >
              {'-'}
            </Typography>
          </Box>
        )}
      </>
    );
  };

  const RenderOPScore = () => {
    return (
      <Typography
        sx={{
          color: Colors.blackPearl,
          fontSize: FontSizes.fontSize14,
          fontFamily: fontSecondary,
          lineHeight: '22px',
          fontWeight: 600,
        }}
      >
        {data?.overprivilege_score?.overprivilege_score}
      </Typography>
    );
  };

  const RenderTeamRiskScore = () => {
    return data?.team_risk_score ? (
      <Typography
        sx={{
          color: Colors.binge,
          fontFamily: fontSecondary,
          fontSize: FontSizes.fontSize14,
          gap: '5px',
          cursor: 'pointer',
        }}
        onClick={handlePieChartOpen}
      >
        {data?.team_risk_score}
      </Typography>
    ) : (
      <Typography>-</Typography>
    );
  };

  const RenderLink = ({ title, url }: { title: string; url: string }) => {
    return (
      <Typography>
        <Link
          sx={{
            color: Colors.binge,
            fontFamily: fontSecondary,
            fontSize: FontSizes.fontSize14,
            gap: '5px',
            cursor: 'pointer',
          }}
          rel="noopener"
          href={url}
          target="_blank"
          underline="none"
          data-testid={INFO_COMPONENT_PROFILE_LINK}
        >
          {title === 'profile' ? (
            <RenderSourceCell source={source} />
          ) : title === 'login' ? (
            `${data?.login}`
          ) : (
            `${data?.name}`
          )}
        </Link>
      </Typography>
    );
  };

  const RenderDate = ({ date }: any) => {
    return (
      <Typography
        sx={{
          color: Colors.blackPearl,
          fontSize: FontSizes.fontSize14,
          fontFamily: fontSecondary,
          fontWeight: 600,
        }}
      >
        {date ? dayjs(date).format('MMM DD, YYYY - LT') : '-'}
      </Typography>
    );
  };

  const RenderEntityGraph = () => {
    return (
      <>
        {goToEntityGraph && (
          <Button
            sx={{
              padding: 0,
              minWidth: 0,
              width: '100%',
            }}
            onClick={() => goToEntityGraph()}
            data-testid={INFO_COMPONENT_ENTITY_GRAPH_LINK}
          >
            <EntityGraphIcon
              style={{
                color: Colors.binge,
                width: '20px',
                height: '20px',
              }}
            />
          </Button>
        )}
      </>
    );
  };

  const RenderRepositoriesWithAccess = () => {
    return (
      <Typography
        sx={{
          color: Colors.blackPearl,
          fontSize: FontSizes.fontSize14,
          fontFamily: fontSecondary,
          lineHeight: '22px',
          fontWeight: 600,
        }}
      >
        {!data?.total_repos ? '0' : getReposDetailsString(data)}
      </Typography>
    );
  };

  const RenderOSSReadMore = () => {
    return (
      <Typography
        onClick={() => {
          if (data?.readme) {
            handleOssOpen();
            setIsReadMore(true);
          }
        }}
        sx={{
          color: Colors.binge,
          fontFamily: fontSecondary,
          fontSize: FontSizes.fontSize14,
          gap: '5px',
          cursor: data?.readme ? 'pointer' : 'default',
        }}
        data-testid={OPENSOURCE_DETAILS_README_LINK}
      >
        {data?.name ? data?.name : ''}
      </Typography>
    );
  };

  const RenderPackageManager = () => {
    return (
      <Typography>
        <Link
          sx={{
            color: Colors.binge,
            fontFamily: fontSecondary,
            fontSize: FontSizes.fontSize14,
            gap: '5px',
            cursor: 'pointer',
          }}
          rel="noopener"
          href={data?.package_ur}
          data-testid={OPENSOURCE_DETAILS_PACKAGE_LINK}
          target="_blank"
          underline="none"
        >
          <CustomSvgIcon
            sx={{
              fontSize: 18,
              mr: 1,
              verticalAlign: 'text-bottom',
              color: Colors.binge,
            }}
          >
            {data?.package_manager === 'NPM' && <NPMIcon />}
            {(data?.package_manager === 'PyPI' ||
              data?.package_manager === 'pip') && <PyIcon />}
            {data?.package_manager.toLocaleUpperCase() === 'MAVEN' && (
              <MavenIcon />
            )}
          </CustomSvgIcon>
          {data?.package_manager || ''}
        </Link>
      </Typography>
    );
  };

  const RenderSecurityAdvisories = () => {
    return (
      <Button
        size="small"
        sx={{
          py: 0,
          my: 0,
          height: '16px',
          color: Colors.binge,
          fontFamily: fontSecondary,
          fontSize: FontSizes.fontSize14,
          gap: '5px',
        }}
        startIcon={
          <CustomSvgIcon
            iconColor={Colors.binge}
            sx={{ fontSize: FontSizes.fontSize14 }}
          >
            <ShieldIcon />
          </CustomSvgIcon>
        }
        onClick={() => {
          if (data?.advisories?.length && data?.advisories?.length > 0)
            handleOssOpen();
        }}
        data-testid={OPENSOURCE_DETAILS_ADVISORIES_MODAL_LINK}
      >
        {data?.advisories?.length || 0}
      </Button>
    );
  };
  const RenderVulnerabilityCell = () => {
    const dispatch = useDispatch();
    if (!data?.vulnerability_counts) return <>-</>;
    const keys = ['oss', 'secret', 'sast', 'iac'];
    const sum = keys?.reduce((acc: number, key: string) => {
      if (data.vulnerability_counts[key])
        return acc + data.vulnerability_counts[key];
      return acc;
    }, 0);
    const handleClick = () => {
      dispatch(
        openModalByNameAction({
          type: PlainModals.ASSET_VULNERABILITY_COUNTS_MODAL,
          metaData: {
            vulnerabilityCounts: data?.vulnerability_counts,
            repo: data?.repo_slug,
            owner: data?.org,
            source: data?.source,
          },
        }),
      );
    };
    return sum > 0 ? (
      <TableCellWithLink
        dataTestId="vulnerability_counts_cell"
        handleClick={handleClick}
        itemTitle={sum}
        isActive
      />
    ) : (
      <>-</>
    );
  };

  const RenderVisibility = () => {
    return (
      <Typography
        color={Colors.blackPearl}
        fontWeight={600}
        fontSize={FontSizes.fontSize14}
      >
        {String(data.visibility).charAt(0).toUpperCase() +
          String(data.visibility).slice(1)}
      </Typography>
    );
  };

  return (
    <Box
      sx={{
        background: Colors.white,
        border: `1px solid ${Colors.sectionBorder}`,
        borderRadius: '10px',
        padding: '15px',
        marginTop: '10px',
        marginBottom: marginBottom || '20px',
        boxShadow: `0px 5px 50px 0px ${Colors.lightSilver}`,
      }}
    >
      <ContainerWithLoader isError={isError} isLoading={isLoading}>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '5px',
          }}
        >
          {infoStructure.map((item) => {
            if (extraCellsRenderObj && extraCellsRenderObj[item.id]) {
              return extraCellsRenderObj[item.id](item);
            }
            return (
              <Box
                sx={{
                  gap: '5px',
                  minWidth: item.id === 'display_name' ? '150px' : null,
                  marginRight: '20px',
                }}
                key={item?.id}
              >
                <Typography
                  sx={{
                    color: Colors.darkGray,
                    fontFamily: fontSecondary,
                    fontSize: FontSizes.fontSize12,
                    fontWeight: 500,
                    mb: '5px',
                  }}
                >
                  {item.title}
                </Typography>
                {item.isDate ? (
                  <RenderDate date={data ? data[item.id] : ''} />
                ) : item.id === 'display_name' ? (
                  <RenderDisplayName />
                ) : item.id === 'team_risk_score' ? (
                  <RenderTeamRiskScore />
                ) : item.id === 'highest_severity' ? (
                  <RenderRiskRating isLinked={item?.isLinked} />
                ) : item.id === 'visibility' ? (
                  <RenderVisibility />
                ) : item.id === 'overprivilege_score' ? (
                  <RenderOPScore />
                ) : item.id === 'profile' ||
                  item.id === 'name' ||
                  item.id === 'login' ? (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                    }}
                  >
                    <RenderLink
                      title={item.id}
                      url={
                        data?.url
                          ? data?.url
                          : data?.source === 'JFrog'
                          ? `https://jfrog.com/${data?.repo_slug}`
                          : `https://github.com/${data?.login}`
                      }
                    />
                  </Box>
                ) : item.id === 'status_active' ? (
                  renderStatus(data)
                ) : item.id === 'entity_graph' ? (
                  <RenderEntityGraph />
                ) : item.id === 'total_repos' ? (
                  <RenderRepositoriesWithAccess />
                ) : item.id === 'status' ? (
                  renderStatus(data)
                ) : item.id === 'oss_name' ? (
                  <RenderOSSReadMore />
                ) : item.id === 'package_manager' ? (
                  <RenderPackageManager />
                ) : item.id === 'repository_url' ? (
                  <RenderLink title={'profile'} url={data?.repository_url} />
                ) : item.id === 'advisories' ? (
                  <RenderSecurityAdvisories />
                ) : item.id === 'vulnerabilities' ? (
                  <RenderVulnerabilityCell />
                ) : item.id === 'source' ? (
                  <RenderSourceCell source={data?.source} />
                ) : data && data[item.id] ? (
                  <Typography
                    color={Colors.blackPearl}
                    fontWeight={600}
                    fontSize={FontSizes.fontSize14}
                  >
                    {data[item.id]}
                  </Typography>
                ) : (
                  <Typography color={Colors.blackPearl}>-</Typography>
                )}
              </Box>
            );
          })}
          {id && typeof id === 'string' && !noWatchHide && (
            <VisibilityButton
              id={data?.login || id}
              watched={data?.watched}
              hidden={data?.hidden}
              switchWatched={changeItemWatch}
              switchHidden={changeItemHide}
              source={source}
            />
          )}
        </Box>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          PaperProps={{
            style: {
              backgroundColor: Colors.white,
              padding: '20px 15px',
              maxWidth: '80vw',
              borderRadius: '15px',
              paddingBottom: '5px',
            },
          }}
          data-testid={IDENTITY_MULTI_TOOL_MODAL}
        >
          <DialogTitle sx={{ m: 0, p: 0 }}>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: FontSizes.fontSize20,
                  fontWeight: 600,
                  fontFamily: fontPrimary,
                  color: Colors.blackPearl,
                }}
              >
                Multi-Tool Status
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  color: Colors.darkGray,
                }}
              >
                <CloseIcon style={{ width: '16px' }} color={Colors.darkGray} />
              </IconButton>
            </Box>
          </DialogTitle>
          {open && (
            <TableComponent
              tableId={IDENTITY_MULTI_TOOL_TABLE}
              isListLoading={false}
              isListErrored={false}
              isEmptyList={data?.multi_tool_status?.length === 0}
              isListFetching={false}
              dataTestId={IDENTITY_MULTI_TOOL_TABLE}
              list={data?.multi_tool_status || []}
              tableColumns={multiToolTableStructure}
              notPaginated={true}
              extraCellsRenderObj={extraTableCellsRenderObject}
            />
          )}
        </Dialog>
        <Dialog
          open={openOss}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleOssClose}
          PaperProps={{
            style: {
              backgroundColor: Colors.white,
              padding: '20px 15px',
              maxWidth: '80vw',
              borderRadius: '15px',
            },
          }}
          data-testid={OPENSOURCE_INFO_COMPONENT_MODAL}
        >
          <DialogTitle sx={{ m: 0, p: 0 }}>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              {isReadMore ? (
                <>
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: FontSizes.fontSize20,
                      fontWeight: 600,
                      fontFamily: fontPrimary,
                      color: Colors.blackPearl,
                    }}
                  >
                    {data?.name} Readme
                  </Typography>
                </>
              ) : (
                <Box display="flex" flexDirection="row" alignItems={'center'}>
                  <ShieldIcon
                    style={{
                      width: '18px',
                      height: '18px',
                      color: Colors.blackPearl,
                      marginRight: '10px',
                    }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: FontSizes.fontSize18,
                      fontWeight: 600,
                      fontFamily: fontPrimary,
                      color: Colors.blackPearl,
                    }}
                  >
                    Security Advisories ({data?.advisories?.length || 0})
                  </Typography>
                </Box>
              )}

              <IconButton aria-label="close" onClick={handleOssClose}>
                <CloseIcon style={{ width: '16px' }} />
              </IconButton>
            </Box>
          </DialogTitle>
          {isReadMore ? (
            <Box sx={{ background: Colors.white, px: 2, my: 2 }}>
              <ReactMarkdown children={data?.readme ? data?.readme : ''} />
            </Box>
          ) : (
            <PackageAdvisoryModal data={data} />
          )}
        </Dialog>
        <Dialog
          open={openPieChart}
          fullWidth
          maxWidth="md"
          onClose={handlePieChartClose}
          sx={{
            '.MuiDialog-paper': {
              backgroundColor: Colors.white,
            },
          }}
        >
          <DialogContent sx={{ p: '15px' }}>
            <PieChart id={id} team={data?.name || ''} />
          </DialogContent>
          <DialogActions>
            <StyledButton
              onClick={handlePieChartClose}
              variant="outlined"
              color="error"
              size="medium"
            >
              Close
            </StyledButton>
          </DialogActions>
        </Dialog>
      </ContainerWithLoader>
    </Box>
  );
};
